<div style="vertical-align: top; margin: 20px; min-height: 700px; min-width: 1400px;">
  <p-panel header="Filtr" [toggleable]="true">
    <div class="ui-g ui-fluid">
      <div class="ui-g-12 ui-md-2">
        <label class="label">Data min:</label>
        <p-calendar [(ngModel)]="parent.filter.dateFrom"
                    [readonlyInput]="false"
                    dateFormat="yy-mm-dd"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [locale]="pl">
        </p-calendar>
      </div>
      <div class="ui-g-12 ui-md-2">
        <label class="label">Data max:</label>
        <p-calendar [(ngModel)]="parent.filter.dateUntil"
                    [readonlyInput]="false"
                    dateFormat="yy-mm-dd"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    [locale]="pl">
        </p-calendar>
      </div>
      <div class="ui-g-12 ui-md-2">
        <label class="label">Najemca:</label>
        <p-dropdown name="company" [options]="companiesOptions" [showClear]="true" [(ngModel)]="parent.filter.tenantId" placeholder="Najemca"></p-dropdown>
      </div>
      <div class="ui-g-12 ui-md-2">
        <label class="label">Parking:</label>
        <p-dropdown name="carparkId" [options]="carparksOptions" [showClear]="true" [(ngModel)]="parent.filter.carparkId" placeholder="Parking"></p-dropdown>
      </div>
      <div class="ui-g-12 ui-md-2">
        <label class="label">Imię:</label>
        <input type="text" pInputText [(ngModel)]="parent.filter.firstName" />
      </div>
      <div class="ui-g-12 ui-md-2">
        <label class="label">Nazwisko:</label>
        <input type="text" pInputText [(ngModel)]="parent.filter.surname" />
      </div>
      <div class="ui-g-12 ui-md-2">
        <label class="label">Nr rej.:</label>
        <input type="text" pInputText [(ngModel)]="parent.filter.licensePlate" />
      </div>
    </div>
    <p-footer>
      <div class="btn-group">
        <p-button name="search" title="Szukaj" (click)="refreshReservations()" icon="pi pi-search" label="Szukaj"></p-button>
      </div>
    </p-footer>
  </p-panel>
  <div class="btn-group">
    <p-button name="add" [routerLink]="'./details'" title="Dodaj rezerwację" label="Dodaj rezerwację"></p-button>
  </div>
  <p-table [value]="reservations" [paginator]="true" [rows]="15" [(first)]="parent.first">
    <ng-template pTemplate="header">
      <tr style="white-space: nowrap;">
        <th width="8%">Start</th>
        <th width="8%">Koniec</th>
        <th width="15%">Najemca</th>
        <th width="10%">Parking</th>
        <th width="12%">Imię</th>
        <th width="12%">Nazwisko</th>
        <th width="10%">Nr rejestracyjny</th>
        <th width="15%">E-mail</th>
        <th width="10%">Akcja</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-reservation>
      <tr style="white-space: normal; overflow-wrap: break-word;">
        <td>{{reservation.dateFrom | date:'yyyy-MM-dd HH:mm'}}</td>
        <td>{{reservation.dateUntil | date:'yyyy-MM-dd HH:mm'}}</td>
        <td>{{companies.get(reservation.tenantId)}}</td>
        <td>{{carparks.get(reservation.carparkId)}}</td>
        <td>{{reservation.firstName}}</td>
        <td>{{reservation.surname}}</td>
        <td>{{reservation.licensePlate}}</td>
        <td>{{reservation.email}}</td>
        <td>
          <fa-stack *ngIf="reservation.status != 'CANNOT_CANCEL' && reservation.status != 'CANCELLED_TO_SYNCHRONIZE' && reservation.status != 'CANCELLED'" size="1x" style="cursor: pointer; float: right;" (click)="cancelReservation(reservation.id)" title="Usuń">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="times" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
          <fa-stack size="1x" style="cursor: pointer; float: right;" [routerLink]="'./details/' + reservation.id" title="Podgląd">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="edit" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
